export default __webpack_public_path__ + "static/media/backend.7d2906fd.svg";